import { render, staticRenderFns } from "./ManageFacilities.vue?vue&type=template&id=d0ca1f72"
import script from "./ManageFacilities.vue?vue&type=script&lang=js"
export * from "./ManageFacilities.vue?vue&type=script&lang=js"
import style0 from "./ManageFacilities.vue?vue&type=style&index=0&id=d0ca1f72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports